import { Person } from './Person'


export class User extends Person {
	constructor (payload, api) {
		super (payload, api);
		this.permissions = payload.permissions || [];
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/JMan/Entity/User.js